var _path, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRewind(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00599 10.3903C2.00599 9.77386 2.2 9.15507 2.58802 8.65956C2.66078 8.56235 3.0003 8.16168 3.26707 7.90088L3.41258 7.75863C5.44971 5.59878 10.5183 2.35071 13.089 1.30991C13.089 1.2862 14.6168 0.667406 15.3444 0.646069H15.4414C16.5569 0.646069 17.5998 1.26012 18.1333 2.25588C18.4243 2.80355 18.6911 4.39202 18.7153 4.41336C18.9336 5.83824 19.0791 8.01943 19.0791 10.414C19.0791 12.9247 18.9336 15.2031 18.6668 16.6019C18.6668 16.6256 18.4001 17.9059 18.2303 18.3326C17.9635 18.9467 17.4785 19.4707 16.8722 19.8026C16.3872 20.0373 15.8779 20.1582 15.3444 20.1582C14.7866 20.1321 13.7438 19.7789 13.3315 19.6129C10.6153 18.5697 5.42546 15.1557 3.43683 13.0693C3.09731 12.7374 2.73353 12.332 2.63653 12.2395C2.22425 11.718 2.00599 11.0778 2.00599 10.3903Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.60156,
    y: 20.1582,
    width: 2.60162,
    height: 19.5121,
    transform: "rotate(-180 2.60156 20.1582)",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewind);
export default __webpack_public_path__ + "static/media/rewind.186bb56aa724ac4bfad709e590a8adcd.svg";
export { ForwardRef as ReactComponent };